import { CrmPitchConceptStatus } from "../../models/crmStatus";
import { PitchPageScope } from "../scopes";
import { createOnboardingAsyncAction } from "./helpers/actionCreators";

export type PitchPageData = {
  pitchConceptId: string;
  formData: unknown;
  state: {
    id: string;
    status?: CrmPitchConceptStatus;
    approvalStatusComments?: string;
  } | null;
  isDraft: boolean;
  canEdit: boolean;
  canSubmit: boolean;
  selections?: unknown;
};

export enum PitchPageActions {
  FETCH_START = "@pitchPage/FETCH_START",
  FETCH_COMPLETED = "@pitchPage/FETCH_COMPLETED",
  FETCH_ERROR = "@pitchPage/FETCH_ERROR",
  SAVE_START = "@pitchPage/SAVE_START",
  SAVE_COMPLETED = "@pitchPage/SAVE_COMPLETED",
  SAVE_ERROR = "@pitchPage/SAVE_ERROR",
  SUBMIT_START = "@pitchPage/SUBMIT_START",
  SUBMIT_COMPLETED = "@pitchPage/SUBMIT_COMPLETED",
  SUBMIT_ERROR = "@pitchPage/SUBMIT_ERROR",
}

export const pitchPageActions = {
  fetchPitchConcept: createOnboardingAsyncAction(
    PitchPageScope,
    PitchPageActions.FETCH_START,
    (pitchConceptId: string) => ({ pitchConceptId }),
    PitchPageActions.FETCH_COMPLETED,
    (data: PitchPageData) => ({ data }),
    PitchPageActions.FETCH_ERROR,
    (error: Error) => ({ error })
  ),
  savePitchConcept: createOnboardingAsyncAction(
    PitchPageScope,
    PitchPageActions.SAVE_START,
    (pitchConceptId: string, isDraft: boolean, formDataPayload?: Record<string, unknown>) => ({
      pitchConceptId,
      isDraft,
      formDataPayload,
    }),
    PitchPageActions.SAVE_COMPLETED,
    (data: unknown) => ({ data }),
    PitchPageActions.SAVE_ERROR,
    (error: Error) => ({ error })
  ),
  submitPitchConcept: createOnboardingAsyncAction(
    PitchPageScope,
    PitchPageActions.SUBMIT_START,
    (pitchConceptId: string, isDraft?: boolean, formDataPayload?: Record<string, unknown>) => ({
      pitchConceptId,
      isDraft,
      formDataPayload,
    }),
    PitchPageActions.SUBMIT_COMPLETED,
    (data: unknown) => ({ data }),
    PitchPageActions.SUBMIT_ERROR,
    (error: Error) => ({ error })
  ),
};
